import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Legacy route: document review now happens after category selection.
 * Old links redirect to the start of the patient flow.
 */
export default function UploadComplete() {
  return <Navigate to="/request/new" replace />;
}
